/// <amd-module name="Wit/Search/BaseProvider" />
import React = require("react");
import { ObservableValue } from "VSS/Core/Observable";
import { VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { ISearchProvider, ISearchQuery, ISearchResult, ISearchStatus } from "VSS/Platform/Search";
import { WorkitemSearchResultComponent } from "./SearchResult";
import { IWorkItemService } from "Wit/WorkItem/Service/Contracts";
import * as _WorkItemTrackingRestClient from "Wit/Clients/Wit/RestClient/WorkItemTracking.Types";

export class WorkitemSearchBaseProvider extends VssService implements ISearchProvider {
    public execute(searchQuery: ISearchQuery): ISearchStatus {
        return { searchQuery: searchQuery, searchResult: new ObservableValue<ISearchResult | undefined>(undefined) };
    }

    public render(searchStatus: ISearchStatus): JSX.Element {
        return <WorkitemSearchResultComponent searchStatus={searchStatus} />;
    }

    public performAction(searchQuery: ISearchQuery): Promise<boolean> {
        const VALID_WORKITEM_REGEX: RegExp = /^\s*#?(\d{1,9})\s*$/;
        const matchInteger = searchQuery.queryText.match(VALID_WORKITEM_REGEX);
        const workItemId = matchInteger ? parseInt(matchInteger[1], 10) : 0;

        if (workItemId > 0) {
            const client = this.pageContext.getRestClient<_WorkItemTrackingRestClient.IWorkItemTrackingRestClient>("IWorkItemTrackingRestClient");
            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");

            return Promise.all([
                client.getWorkItem(workItemId, undefined, ["System.Id"]),
                contributionService.getService<IWorkItemService>("ms.vss-work-web.work-item-service")
            ]).then(
                ([workItem, service]) => {
                    if (service) {
                        service.openWorkItem(workItemId);
                    }

                    return true;
                },
                (error: Error) => {
                    return Promise.resolve(false); // We want derived class to execute its performAction method
                }
            );
        } else {
            return Promise.resolve(false);
        }
    }
}
